import Axios from "axios";
import {
    SET_ASSET_MAPPING_LIST,
    UNSET_ASSET_MAPPING_LIST,
} from "@/store/mutation-types";

import { saveUpdatAssetMapping, getAssetMapplingsList } from "@/store/api";

const state = {
    getAssetMapplingsList: [],
};

const getters = {
    getAssetMapplingsList(state) {
        return state.getAssetMapplingsList;
    }
};

const mutations = {
    [SET_ASSET_MAPPING_LIST](state, data) {
        state.getAssetMapplingsList = data;
    },
    [UNSET_ASSET_MAPPING_LIST](state) {
        state.getAssetMapplingsList = [];
    }
};

const actions = {
    saveUpdatAssetMapping({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdatAssetMapping, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetMapplingsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetMapplingsList, data)
                .then(function (response) {
                    commit('SET_ASSET_MAPPING_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_MAPPING_LIST');
                    reject(error);
                })
                .then((always) => {
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
